const SET_CATEGORIES = 'SET_CATEGORIES';

export { SET_CATEGORIES };
